import _ua from '../../plugins/is-ua.js';

//電話番号スマホのみ掛ける
$("a[href*='tel:']").on("click", function(e){
  if(!_ua().Mobile || !_ua().Tablet){
    return false
  }
});